import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialPinterestIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialPinterest",
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.66 29.91c1-1.31 1.8-2.83 2.34-4.48l.03-.11s.21-.74 1.15-4.56a4.71 4.71 0 0 0 3.9 2.06h.16c5.32 0 8.94-4.86 8.94-11.35 0-4.91-4.17-9.48-10.49-9.48-7.87 0-11.83 5.65-11.83 10.34 0 2.83 1.09 5.37 3.45 6.31.08.05.18.07.29.07a.6.6 0 0 0 .58-.48c.08-.29.23-1.02.33-1.33a.799.799 0 0 0-.23-.92 4.87 4.87 0 0 1-1.1-3.09v-.28a7.83 7.83 0 0 1 7.83-7.83h.33-.02c4.45 0 6.89 2.7 6.89 6.33 0 4.78-2.11 8.81-5.24 8.81h-.08a2.59 2.59 0 0 1-2.51-3.23v.02c.5-2.09 1.44-4.31 1.44-5.85 0-1.35-.72-2.5-2.21-2.5-1.72 0-3.18 1.84-3.18 4.31 0 .96.2 1.86.55 2.69l-.02-.05c-1.9 7.66-2.23 9.01-2.23 9.01-.2.98-.31 2.1-.31 3.25 0 .81.06 1.61.16 2.39v-.09h1.08Z"
    })
  }));
};